export default class CacheItem {
    promise = null;
    ttl = 60 * 30;
    expiresAt = null;
    requestor = null;

    constructor(requestor, ttl = 60 * 5) {
        this.requestor = requestor;
        this.ttl = ttl;
    }

    getPromise() {
        if (null === this.promise || this.isExpired()) {
            this.promise = this.requestor();
            this.promise.catch(() => {
                this.promise = null;
            });
            this.expiresAt = new Date();
            this.expiresAt.setSeconds(this.expiresAt.getSeconds() + this.ttl);
        }

        return this.promise;
    }

    isExpired() {
        return (new Date()) > this.expiresAt;
    }
};
